import I18n from 'i18n'
import React, { Fragment } from 'react'
import { Badge, LockIcon } from 'stylist'

const RestrictedWorkspacesWidget = () => (
  <Fragment>
    <div className="dashboard-sub" />
    <div className="dashboard-empty-workspace">
      <h6>{I18n.t('There are no Workspaces available at this time.')}</h6>
      <div className="marginTop10">
        <Badge kind="pro">
          <LockIcon size="s" />
        </Badge>
        <span style={{ marginLeft: '.5rem' }}>
          {I18n.t('Workspaces are available with a subscription.')}
        </span>
      </div>
    </div>
  </Fragment>
)

export default RestrictedWorkspacesWidget



// WEBPACK FOOTER //
// ../src/components/RestrictedWorkspacesWidget.js